import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=447e07c3&"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/scss/custom/_confirmDeleteModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports